/**
 * @author       grady@zumper.com (Grady Kuhnline)
 * @copyright    Copyright (c) 2018, Zumper
 * @description  Returns the match for an array of routes given a location
 */

import type { Location } from 'history'
import invariant from 'tiny-invariant'
import { matchPath } from './matchPath'
import type { ZumperRoute, match } from './types'

export const findMatch = <
  Params extends { [K in keyof Params]?: string | undefined } = {},
>(
  routes: (string | ZumperRoute<Params>)[],
  location: Location<unknown>
): match<Params> | null => {
  invariant(Array.isArray(routes), 'routes must be an array')
  const { pathname } = location
  let match: match<Params> | null | undefined
  routes.some((route: string | ZumperRoute<Params>) => {
    match = matchPath(pathname, route)
    return match !== null
  })
  return match ?? null
}
